import type { Resource } from '../../';
export const country_countries_SG: Resource = {"default":"Singapore"};
